import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feddc89e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "footer-top" }
const _hoisted_4 = {
  href: 'https://www.linkedin.com/company/g14c/',
  target: "_blank",
  class: "linkedin-link"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "certifications" }, [
  /*#__PURE__*/_createElementVNode("a", { herf: "#" }, "CMMI-DEV Level 3"),
  /*#__PURE__*/_createElementVNode("a", { herf: "#" }, "CMMI-SVC Level 3"),
  /*#__PURE__*/_createElementVNode("a", { herf: "#" }, "ISO 9001"),
  /*#__PURE__*/_createElementVNode("a", { herf: "#" }, "ISO 20000"),
  /*#__PURE__*/_createElementVNode("a", { herf: "#" }, "ISO 27001")
], -1))
const _hoisted_7 = { class: "footer-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-bottom-left m-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© G14C LLC All Rights Reserved")
], -1))
const _hoisted_9 = { class: "footer-bottom-right m-2" }

import router  from "@/router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

  function routeToLink(link: any){
    router.push({ name: link })
    window.scrollTo(0, 0);
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (routeToLink('about-us'))),
          class: "footer-link"
        }, "About Us"),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (routeToLink('contact-us'))),
          class: "footer-link"
        }, "Contact Us"),
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/contact/linkedin.png'),
            alt: "LinkedIn",
            class: "linkedin-icon"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: "/privacy-statement" }, {
            default: _withCtx(() => [
              _createTextVNode("Privacy Statement")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/terms-of-use" }, {
            default: _withCtx(() => [
              _createTextVNode("Terms of Use")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/accessibility" }, {
            default: _withCtx(() => [
              _createTextVNode("Accessibility")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})